// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PDeleteTeamOutlinedSvg from "@fishx/icons-svg/es/asn/PDeleteTeamOutlined";
import FishxIcon from '../components/FishxIcon';

var PDeleteTeamOutlined = function PDeleteTeamOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PDeleteTeamOutlinedSvg
  }));
};

PDeleteTeamOutlined.displayName = 'PDeleteTeamOutlined';
export default React.forwardRef(PDeleteTeamOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PDeleteTeamOutlined.js
// module id = 3321
// module chunks = 0